/* 🤖 this file was generated by svg-to-ts */
export const mgcIconXSkewFilled: {
  name: 'x-skew-filled';
  data: string;
} = {
  name: 'x-skew-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.949 3.217c-.291.12-.544.325-.702.572C2.985 4.198 3 3.685 3 12s-.015 7.802.247 8.211c.262.408.667.635 1.173.658.286.012 1.11-.135 7.754-1.384 7.139-1.342 7.446-1.403 7.726-1.541a2.055 2.055 0 0 0 1.057-1.401c.06-.331.06-8.755 0-9.086A2.055 2.055 0 0 0 19.9 6.056c-.28-.138-.584-.199-7.726-1.539-5.3-.995-7.514-1.395-7.714-1.395-.203 0-.344.026-.511.095"/></svg>`
};
